export {
  MorphemeDetailsTileLink,
  type MorphemeDetailsTileLinkProps,
} from "#morpheme-details-tile-link";
